import { Appointment, AppointmentStatus } from 'src/gql/graphql';
import { Modal, ModalBase } from 'src/ui/components/Modal/Modal';
import { AppointmentStatusTag } from 'src/pages/_components/AppointmentStatusTag/AppointmentStatusTag';
import { Button } from 'src/ui/components/Button';
import { useState } from 'react';
import cn from 'classnames';
import styles from './BadStatusAppointmentModal.module.scss';
import { Heading } from '../../../../../../ui/components/Heading/Heading';

interface BadStatusAppointmentModalI extends ModalBase {
  appointment: Appointment;
  onStatusChange?: (status: AppointmentStatus) => void;
}
export const BadStatusAppointmentModal = ({
  isOpen,
  setIsOpen,
  appointment,
  onStatusChange,
}: BadStatusAppointmentModalI) => {
  const [selectedStatus, setSelectedStatus] = useState<AppointmentStatus>(
    AppointmentStatus.Completed
  );
  const renderAOptions = () => {
    const availableOptionsToChange = [
      AppointmentStatus.Completed,
      AppointmentStatus.Canceled,
    ];

    return availableOptionsToChange.map((status) => (
      <Button
        className={cn(styles.status, {
          [styles.unselected]: status !== selectedStatus,
        })}
        key={status}
        onClick={() => {
          setSelectedStatus(status);
        }}
      >
        <AppointmentStatusTag
          className={cn({
            [styles.unselected]: status !== selectedStatus,
          })}
          status={status}
        />
      </Button>
    ));
  };
  return (
    <Modal
      isOpen={isOpen}
      className={styles.root}
      onClose={() => setIsOpen(false)}
    >
      <Heading className={styles.heading} headingLevel="h2">
        Estado de cita incorrecto
      </Heading>
      <div className={styles.description}>
        Esta cita puede tener un estado incorrecto. Por favor seleccione la
        opción más apropiada para tu caso
      </div>
      <div className={styles.options}>{renderAOptions()}</div>
      <div className={styles.actions}>
        <Button
          className={styles.cancel}
          onClick={() => {
            setIsOpen(false);
          }}
        >
          Cancelar
        </Button>
        <Button
          btnStyle="secondary"
          onClick={() => {
            if (onStatusChange) {
              onStatusChange(selectedStatus);
            }
            setIsOpen(false);
          }}
        >
          Cambiar estado
        </Button>
      </div>
    </Modal>
  );
};
